(() => {
    document.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-mm-review-request]');
              if (!trigger) return;
                  const contact = document.getElementById('mommode-contact');
                      if (!contact) return;
                          const topic = contact.querySelector('[data-mm-topic]');
                              const fields = contact.querySelector('[data-mm-review-fields]');
                                  if (topic) topic.value = 'Partilhar avaliação';
                                      if (fields) fields.open = true;
    });
      document.addEventListener('change', (event) => {
            if (!event.target.matches('[data-mm-topic]')) return;
                const form = event.target.closest('form');
                    const fields = form?.querySelector('[data-mm-review-fields]');
                        if (fields && event.target.value === 'Partilhar avaliação') fields.open = true;
      });

        // Mantém o contador personalizado alinhado com o carrinho nativo do Horizon.
          let cartUpdateVersion = 0;
            const renderCartCount = (count) => {
                  if (!Number.isInteger(count) || count < 0) return;
                      document.querySelectorAll('.mm-cart-link span').forEach((counter) => {
                              counter.textContent = String(count);
                                    counter.setAttribute('aria-label', `${count} artigos`);
                      });
            };
              const syncCartCount = async () => {
                    const version = ++cartUpdateVersion;
                        try {
                                const root = window.Shopify?.routes?.root || '/';
                                      const response = await fetch(`${root}cart.js`, {
                                                credentials: 'same-origin',
                                                        cache: 'no-store',
                                                                headers: { Accept: 'application/json' },
                                      });
                                            if (!response.ok) return;
                                                  const cart = await response.json();
                                                        if (version === cartUpdateVersion) renderCartCount(cart.item_count);
                        } catch (_) {
                                // Falhas de rede não devem interferir com a compra nem com o formulário.
                        }
              };
                const onCartLinesUpdate = (event) => {
                      const version = ++cartUpdateVersion;
                          if (!event.promise || typeof event.promise.then !== 'function') {
                                  syncCartCount();
                                        return;
                          }
                              event.promise.then(({ cart, detail } = {}) => {
                                      if (version !== cartUpdateVersion) return;
                                            const count = cart?.totalQuantity ?? detail?.itemCount;
                                                  if (Number.isInteger(count) && count >= 0) renderCartCount(count);
                                                        else syncCartCount();
                              }).catch(() => {
                                      if (version === cartUpdateVersion) syncCartCount();
                              });
                };
                  import('@shopify/events').then(({ StandardEvents }) => {
                        document.addEventListener(StandardEvents.cartLinesUpdate, onCartLinesUpdate);
                            syncCartCount();
                  }).catch(() => {
                        syncCartCount();
                  });
                    window.addEventListener('pageshow', (event) => {
                          if (event.persisted) syncCartCount();
                    });
})();

